import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";

export default function useCountdownClock(endDate) {
  const [clock, setClock] = useState(null);

  useEffect(() => {
    let diff;
    let interval;

    if (endDate) {
      interval = setInterval(() => {
        const now = moment();
        const end = moment(endDate);
        diff = end.diff(now);

        setClock(Math.max(Math.floor(diff / 1000), 0));
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [endDate, clock]);

  const formatClock = () => {
    if (!_.isNumber(clock)) return clock;
    let rem;
    const days = Math.floor(clock / (3600 * 24));
    rem = clock - days * 3600 * 24;
    const hours = Math.floor(rem / 3600);
    rem -= hours * 3600;
    const minutes = Math.floor(rem / 60);
    rem -= minutes * 60;
    const seconds = rem;

    let out = `${_.padStart("" + seconds, 2, "0")}s`;

    if (days > 0 || hours > 0 || minutes > 0)
      out = `${_.padStart("" + minutes, 2, "0")}m ${out}`;

    if (days > 0 || hours > 0)
      out = `${_.padStart("" + hours, 2, "0")}h ${out}`;

    if (days > 0) out = `${days}d ${out}`;

    return out;
  };

  return { seconds: clock, clock: formatClock() };
}
